var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M19.935 6.957l.158.488h.517l-.42.3.165.495-.42-.308-.412.308.157-.495-.42-.3h.518l.157-.488zm-1.837 3.518l.24.735h.772l-.622.45.232.735-.622-.45-.623.45.24-.735-.622-.45h.765l.24-.735zm.067-5.76l.203.615h.637l-.517.375.202.615-.525-.383-.517.383.202-.615-.525-.375h.645l.195-.615zm-1.762 2.22l.232.735h.773l-.623.45.24.735-.622-.45-.623.45.233-.735-.623-.45h.773l.24-.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12-.003V1.43L9.885 2.607H12V5.39H9.225L12 6.928V8h-1.252L7.305 6.088V8h-2.61V5.72L.6 8H0V6.567L2.115 5.39H0V2.608h2.768L0 1.07V-.003h1.252l3.443 1.92v-1.92h2.61v2.28L11.4-.002h.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.75-.003h-1.5v3.256H0v1.5h5.25V8h1.5V4.753H12v-1.5H6.75V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M7.305 5.39L12 8v-.735L8.632 5.39H7.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M7.305 5.39L12 8v-.735L8.632 5.39H7.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M7.305 5.39L12 8v-.735L8.633 5.39H7.304zm-3.937 0L0 7.265V8l4.695-2.61H3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M4.695 2.607L0-.002V.74l3.368 1.868h1.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M4.695 2.607L0-.002V.74l3.368 1.868h1.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M4.695 2.607L0-.002V.74l3.368 1.868h1.327zm3.938 0L12 .74v-.743l-4.695 2.61h1.328z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/NewZealand.bc38c47e36c700e0c26594660a59b4e6.svg";
export { ForwardRef as ReactComponent };